import { TableColumnRegistryContext } from "@organisms/Table/Table.context"
import { TableColumnRegistryContextValues } from "@organisms/Table/Table.types"

import { TableColumnRegistryProps } from "./TableColumnRegistry.types"

// Where the `Table.Column` children register; whoever builds the react-table instance owns the column state.
export default function TableColumnRegistry<T>(props: TableColumnRegistryProps<T>) {
    const { setColumns, children } = props

    // Annotated so the generic setter is accepted by the untyped context.
    const registry: TableColumnRegistryContextValues<T> = { setColumns }

    return <TableColumnRegistryContext.Provider value={registry}>{children}</TableColumnRegistryContext.Provider>
}
